/**
 * Numbers that arrive as `number | string` (SPEC §13.4).
 *
 * The generated types widen every `int32` and `decimal` that way, because JSON
 * can carry either and the server's contract does not narrow it. Screens work
 * in numbers, so the coercion belongs once at the edge rather than at every
 * control that binds to one.
 */
export function asNumber(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null

  const parsed = Number(value)

  return Number.isNaN(parsed) ? null : parsed
}

/** The same, for a value that has to be a number. */
export function asCount(value: number | string | null | undefined, fallback = 0): number {
  return asNumber(value) ?? fallback
}
